// import GSAP
// needed for on slide change animation
import { gsap } from 'gsap';
// import Swiper JS
// import Swiper, { Autoplay, Navigation, EffectCoverflow, EffectFade, FreeMode, Thumbs } from 'swiper';
import Swiper, { Autoplay, Pagination, EffectFade } from 'swiper';
// import Swiper styles
import 'swiper/css';
import 'swiper/css/autoplay';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
// import 'swiper/css/effect-coverflow';
// import 'swiper/css/free-mode';
// import 'swiper/css/thumbs';

let _homepage = document.body.classList.contains('page-template-homepage');
// ! SLIDERS
const __simpleFullSlider = '.default__slider';
// * HOME
const __homeSection1Slider = '.home-section-1';

// ! SLIDER TYPES
const simpleFadeSettings = {
    modules: [Autoplay, Pagination, EffectFade],
    speed: 1000,
    spaceBetween: 0,
    effect: 'fade',
    slidesPerView: 1,
    fadeEffect: {
        crossFade: true,
    },
    on: {
        init: function () {
            // console.log('swiper initialized');
            childrenFadeEffect('.js-fade-slide__children');
        },
    },
};

window.addEventListener('DOMContentLoaded', () => {
    
    // Default can exist only (1) in each page
    if (document.querySelector(__simpleFullSlider + '__slider')) {
        simpleFullSlider(__simpleFullSlider, simpleFadeSettings);
    }

    if (_homepage) {
        if (document.querySelector(__homeSection1Slider + '__slider')) {
            simpleFullSlider(__homeSection1Slider, simpleFadeSettings);
        }
    }
});

let preStractureSlider = (sw) => {
    var swContainer = document.querySelectorAll(sw + '__slider');
    var swWrapper = document.querySelectorAll(sw + '__sliderwrap');
    var swSlides = document.querySelectorAll(sw + '__item');

    if (swContainer && swWrapper && swSlides) {
        swContainer.forEach(function (swC) {
            swC.classList.add('swiper');
            setTimeout(function(){
                swC.parentElement.classList.add('show');
            }, 1000);
            swWrapper.forEach(function (swW) {
                swW.classList.add('swiper-wrapper');
                for (var i = 0; i < swSlides.length; i++) {
                    swSlides[i].classList.add('swiper-slide');
                }
            });
        });
    }
};

let simpleFullSlider = (sw, settings) => {
    preStractureSlider(sw);
    var slider = {};
    var sliderSettings = settings;
    var item = document.querySelectorAll(sw + '__item');
    var itemLength = item.length;
    sliderSettings.loop = itemLength > sliderSettings.slidesPerView;
    // sliderSettings.navigation = {
    //     prevEl: sw + '__item-prev',
    //     nextEl: sw + '__item-next',
    // };
    sliderSettings.pagination = {
        el: sw + '__pagination',
        type: 'bullets',
        clickable: true,
    };
    slider = new Swiper(sw + '__slider', sliderSettings);
    // console.log(slider);
    let thisSliderWrap = document.querySelector(sw + '__sliderwrap');
    thisSliderWrap.querySelector('.swiper-slide-active').classList.add('onPoint');
    slider.on('slideChange', function () {
        // console.log('slide changed');
        thisSliderWrap.querySelector('.swiper-slide-active').classList.remove('onPoint');
        childrenFadeEffect('.js-fade-slide__children');
    });
    slider.on('slideChangeTransitionEnd', function () {
        // console.log('slide changed ended');
        thisSliderWrap.querySelector('.swiper-slide-active').classList.add('onPoint');
    });
}; //OK

let childrenFadeEffect = (target) => {
    const fadeChildren = document.querySelectorAll(target);
    if (fadeChildren.length) {
        fadeChildren.forEach((el) => {
            const showTl = gsap.timeline();
            showTl.fromTo(el.children, { y: 20, opacity: 0 }, { y: 0, opacity: 1, duration: 1, stagger: 0.5, ease: 'ease' });
        });
    }
};